import { Row, Typography } from '@repo/ui/components'
import { useTranslate } from '@repo/shared/hooks'
import type { OrderBoxBestSuggestionProps } from './order-box.types'
import { PaymentType } from '..'

export const OrderBoxBestSuggestion = ({
  type,
  price,
}: OrderBoxBestSuggestionProps) => {
  const { t } = useTranslate()
  const textColor = 'positive-surface' // type === "buy" ? "positive-surface" : "negative-surface";
  return (
    <Row className={`w-fit gap-xs px-lg py-2xs rounded-2xl bg-${textColor}`}>
      <Typography size='2xs' color={`text-${textColor}-100`}>
        {t('order_best_suggestion', {
          type: t(type === 'buy' ? 'order_buy' : 'order_sell'),
        })}
      </Typography>
      <PaymentType
        value={price.toLocaleString()}
        size='2xs'
        numberSize='2xs'
        color={`text-${textColor}-100`}
        numberColor={`text-${textColor}-100`}
      />
    </Row>
  )
}
